import { useFormik } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { useLocalStorage } from "../../../hooks";
import * as dashboardActions from "../../../redux/reducers/dashboardReducer";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";
import * as schoolActions from "../../../redux/reducers/schoolReducer";
import { schoolState } from "../../../redux/reducers/schoolReducer";
import BusinessProfileForm from "./BusinessProfileForm";
import BusinessProfileImgInput from "./BusinessProfileImgInput";

import { MinusCircleIcon } from "@heroicons/react/24/solid";
import facebook_img from "../../../assets/Facebook F.png";
import individual_profile from "../../../assets/individual_profile.svg";
import instagram_img from "../../../assets/Instagram.png";
import institute_img from "../../../assets/Institute.svg";
import linkedIn_img from "../../../assets/LinkedIn 2.png";
import progressdone from "../../../assets/progressdone.svg";
import twitter_img from "../../../assets/Twitter.png";
import web_img from "../../../assets/Website.svg";
import youtube_img from "../../../assets/YouTube.png";
import OtpModal from "../../../components/OtpModal";
import { TwButton, TwConfirmDialog, TwInputGroup, TwTextarea } from "../../../components/tailwind";
import { checkSocialUrl, isUrlValid } from "../../../helpers";
import { useToast } from "../../../provider/ToastProvider";
import { loadingState, setActionLoading, setGlobalLoading } from "../../../redux/reducers/loadingReducer";
import * as userActions from "../../../redux/reducers/userReducer";
import { userState } from "../../../redux/reducers/userReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForUsers } from "../../../utils/confighelpers";
import { useTranslation } from "react-i18next";

export default function EditBusinessProfile({ navigation }) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast, addNotificationDialog, addConfirmDialog } = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const dashboardReduxState = useSelector(dashboardState);
  const schoolReduxState = useSelector(schoolState);
  const userReduxState = useSelector(userState);
  const [userToken] = useLocalStorage("userToken");
  const businessTypePlural = {
    "class": "classes",
    "event": "events",
    "service": "services",
  }
  const businessProfileInfo = {
    "businessProfileType": "business",
    /* ...{
      "address": {
        "addressType": "manually",
        "address": "Rajkot, Gujarat, India",
        "houseNumber": "Rajkot",
        "city": "Rajkot",
        "zip": "",
        "addressName": "Rajkot",
        "location": {
          "type": "Point",
          "coordinates": [
            22.3038945,
            70.80215989999999
          ],
          "_id": "6692b2badddbf9782b8874fb"
        }
      },
      "socialLink": {
        "facebook": "facebook.com/mmmm",
        "instagram": "",
        "youtube": "",
        "linkedIn": "",
        "twitter": ""
      },
      "businessName": "Abhi5 & 51225",
      "businessProfileType": "business",
      "logo": "https://bmcprod.s3.amazonaws.com/css-3-front-end-service.png",
      "images": [
        ""
      ],
      "about": "asasdasdasdsas",
      "workNumber": "+31 55 11111112",
      "workEmail": "abhi.d@yopmail.com",
      "workWebsite": ""
    }, */
    socialLinksSelected: [],
  }

  const [loading, setLoading] = React.useState(false);
  const [otpTitle, setOtpTitle] = React.useState("");
  const [otpSubTitle, setOtpSubTitle] = React.useState("");
  const formik = useFormik({
    initialValues: {
      ...businessProfileInfo
    },
    validate: (values) => {
      const errors = {};
      /* if (values.businessTypes && Object.keys(values.businessTypes).length === 0) {
        errors.businessTypes = t("errors.required");
      } */
      if (!values.businessName) {
        errors.businessName = t("errors.required");
      }
      if (!values.address) {
        errors.address = t("errors.required");
      }
      if (!values.workEmail) {
        errors.workEmail = t("errors.required");
      }

      if (values.workWebsite && values.workWebsite.length > 0 && isUrlValid(values.workWebsite) === false) {
        errors.workWebsite = t("errors.invalidWURL");
      }

      if (values?.socialLink && values?.socialLink?.facebook && values.socialLink.facebook.length > 0 && (isUrlValid(values.socialLink.facebook) === false || checkSocialUrl("facebook", values.socialLink.facebook) === false)) {
        errors['socialLink.facebook'] = t("errors.invalidFURL");
      }

      if (values?.socialLink && values?.socialLink?.instagram && values.socialLink.instagram.length > 0 && (isUrlValid(values.socialLink.instagram) === false || checkSocialUrl("instagram", values.socialLink.instagram) === false)) {
        errors['socialLink.instagram'] = t("errors.invalidIURL");
      }

      if (values?.socialLink && values?.socialLink?.youtube && values.socialLink.youtube.length > 0 && (isUrlValid(values.socialLink.youtube) === false || checkSocialUrl("youtube", values.socialLink.youtube) === false)) {
        errors['socialLink.youtube'] = t("errors.invalidYURL");
      }

      if (values?.socialLink && values?.socialLink?.linkedIn && values.socialLink.linkedIn.length > 0 && (isUrlValid(values.socialLink.linkedIn) === false || checkSocialUrl("linkedIn", values.socialLink.linkedIn) === false)) {
        errors['socialLink.linkedIn'] = t("errors.invalidLURL");
      }

      if (values?.socialLink && values?.socialLink?.twitter && values.socialLink.twitter.length > 0 && (isUrlValid(values.socialLink.twitter) === false || checkSocialUrl("twitter", values.socialLink.twitter) === false)) {
        errors['socialLink.twitter'] = t("errors.invalidTURL");
      }
      // }
      /* if (!values.coverPhoto) {
        errors.coverPhoto = t("errors.required");
      } */
      /* if (Array.isArray(values.categories) && !values.categories?.length) {
        errors.categories = t("errors.required");
      } */

      return errors;
    },
    onSubmit: async (values, { setSubmitting }) => {
      // dispatch(setGlobalLoading(true));
      dispatch(setActionLoading(true));
      // addToast("{t("inputFieldsTitle.loading")}");

      if (
        // values.businessName !== dashboardReduxState.schoolData.businessName &&
        userReduxState?.userData?.myBusinessProfile &&
        values.businessName !== userReduxState?.userData?.myBusinessProfile.businessName &&
        !isDialogShow
      ) {
        dispatch(setGlobalLoading(false));
        dispatch(setActionLoading(false));
        setShowNameChangedModal(true);
        return;
      }
      // if (values.workEmail !== dashboardReduxState.schoolData.workEmail || values.workNumber !== dashboardReduxState.schoolData.workNumber) {
      if (values.workEmail !== userReduxState?.userData?.myBusinessProfile.workEmail || values.workNumber !== userReduxState?.userData?.myBusinessProfile.workNumber) {
        let updateProfileBody = {
          email: values.workEmail,
        };
        setOtpTitle(t("inputFieldsTitle.verifyEmail"));
        setOtpSubTitle(values.workEmail);
        if (values.workNumber !== dashboardReduxState.schoolData.workNumber) {
          setOtpTitle(t("inputFieldsTitle.verifyNumber"));
          setOtpSubTitle(values.workNumber);
          updateProfileBody = {
            countryCode: values.countryCode,
            phoneNumber: values.phone,
          }
        }
        const updateProfileConfig = {
          method: "put",
          url: `${getUrlForUsers()}updateProfile`,
          data: updateProfileBody,
        };
        const updateProfileRequest = await axiosInstance(updateProfileConfig);
        dispatch(setGlobalLoading(false));
        dispatch(setActionLoading(false));
        if (updateProfileRequest.data.statusCode === 200) {
          setOtpToken(updateProfileRequest.data.data.token);
          handleOpenOtpModal();
          return;
        }
        return;
      }
      await updateProfileForAll(values);
      dispatch(setGlobalLoading(false));
      return false; /** new user myBusinessProfile update **/

    },
  });
  const [defaultSocialLinks, setDefaultSocialLinks] = React.useState(
    [
      {
        name: "facebook",
        icon: facebook_img,
        placeholder: "facebook.com/mypage"
      },
      {
        name: "instagram",
        icon: instagram_img,
        placeholder: "instagram.com/mypage"
      },
      {
        name: "linkedIn",
        icon: linkedIn_img,
        placeholder: "linkedin.com/in/myprofile"
      },
      {
        name: "twitter",
        icon: twitter_img,
        placeholder: "twitter.com/mypage"
      },
      {
        name: "youtube",
        icon: youtube_img,
        placeholder: "youtube.com/mychannel"
      }]);
  const [socialLinksSelected, setSocialLinksSelected] = React.useState([]);
  const [isThereChange, setIsThereChange] = React.useState({ od: true, cd: true, sd: true });
  const [openOtpModal, setOpenOtpModal] = React.useState(false);
  const [otpToken, setOtpToken] = React.useState("");
  const [showNameChangedModal, setShowNameChangedModal] = React.useState(false);
  const [isDialogShow, setDialogShow] = React.useState(false);
  const [categories, setCategories] = React.useState([]);
  const [updateLocationConfig, setUpdateLocationConfig] = React.useState({});
  const [locationChanged, setLocationChanged] = React.useState(false);

  React.useEffect(() => {
    const socialArray = [];
    if (formik.values?.socialLink?.facebook) {
      socialArray.push("facebook");
    }
    if (formik.values?.socialLink?.instagram) {
      socialArray.push("instagram");
    }
    if (formik.values?.socialLink?.linkedIn) {
      socialArray.push("linkedIn");
    }
    if (formik.values?.socialLink?.twitter) {
      socialArray.push("twitter");
    }
    if (formik.values?.socialLink?.youtube) {
      socialArray.push("youtube");
    }
    setSocialLinksSelected([...socialArray]);
    formik.setValues({
      // ...businessProfileInfo,
      socialLinksSelected: socialArray
    });
    setTimeout(() => {
      setIsThereChange({ od: true, cd: true, sd: true })
    }, 1 * 1000);
  }, [])

  React.useEffect(() => {

    let myBusinessProfile = userReduxState?.userData?.myBusinessProfile ?? {}
    if (
      myBusinessProfile.logo != formik.values?.logo
      || myBusinessProfile.businessName != formik.values?.businessName
      || myBusinessProfile.about != formik.values?.about
    ) {
      setIsThereChange(
        (prevValues) => ({
          ...prevValues,
          od: false,
        }))
    } else if (
      JSON.stringify(myBusinessProfile.address) != JSON.stringify(formik.values?.address)
      || myBusinessProfile.formattedPhoneNumber != formik.values?.formattedPhoneNumber
      || myBusinessProfile.workNumber != formik.values?.workNumber
      || myBusinessProfile.workEmail != formik.values?.workEmail
    ) {
      setIsThereChange(
        (prevValues) => ({
          ...prevValues,
          cd: false,
        }))
    } else if (
      myBusinessProfile.workWebsite != formik.values?.workWebsite
      || (myBusinessProfile.socialLink && JSON.stringify(myBusinessProfile.socialLink) != JSON.stringify(formik.values?.socialLink))
    ) {
      setIsThereChange(
        (prevValues) => ({
          ...prevValues,
          sd: false,
        }))
    }
  }, [formik.values])

  React.useEffect(() => {
    setCategories([...schoolReduxState.schoolCategories]);
  }, [schoolReduxState]);

  const handleOpenOtpModal = () => { dispatch(setGlobalLoading(false)); setOpenOtpModal(true); }
  const handleCloseOtpModal = () => { dispatch(setGlobalLoading(false)); setOpenOtpModal(false); };
  const updateProfileForAll = async (values) => {

    const schoolUpdateBody = {
      myBusinessProfile: {
        businessName: values.businessName,
        businessTypes: values.businessTypes,
        businessProfileType: values.businessProfileType,
        logo: values.logo,
        images: values.images,
        about: values.about,
        locationObj: values.locationObj,
        typeOfBusiness: "",
        workNumber: values.workNumber,
        workEmail: values.workEmail,
        workWebsite: values.workWebsite,
        socialLink: {
          ...values.socialLink,
        },
        // address: values.locationObj,
        address: { ...(updateLocationConfig?.data ? updateLocationConfig.data : (values?.address || {})) },
      },
    };
    const schoolUpdateConfig = {
      method: "put",
      url: `${getUrlForUsers()}updateProfile`,
      data: schoolUpdateBody,
    };
    dispatch(setGlobalLoading(true));
    dispatch(setActionLoading(true));
    const businessUpdateRequest = await axiosInstance(schoolUpdateConfig);
    dispatch(setActionLoading(false));
    dispatch(setGlobalLoading(false));
    setIsThereChange({ od: true, cd: true, sd: true });
    if (businessUpdateRequest.status === 200) {
      if (businessUpdateRequest.data.statusCode === 200) {
        if (businessUpdateRequest.data.data?.myBusinessProfile.address) {
          formik.setValues({
            ...formik.values,
            address: businessUpdateRequest.data.data?.myBusinessProfile.address,
          });
        }
        dispatch(userActions.setUserData({
          // ...userReduxState.userData,
          appUrl: userReduxState.userData.appUrl,
          // myBookingLink: businessUpdateRequest.data.data.myBookingLink,
          ...businessUpdateRequest.data.data,
        }));
        dispatch(schoolActions.setName(values.businessName));
        dispatch(schoolActions.setLogo(values.logo));
        dispatch(schoolActions.setCover(values.images[0]));
        dispatch(
          dashboardActions.setSchoolData(
            businessUpdateRequest.data.data
          )
        );
        addNotificationDialog({
          dialogType: "success",
          dialogTitle: t("linkDescription.success"),
          dialogMessage: t("successes.businessProfileSuccessfully"),
          dialogBtnTitle: t("inputFieldsTitle.ok"),
        })
        dispatch(dashboardActions.setCalendarSessionId(-1));
        dispatch(dashboardActions.setCalendarOpen(false));
        return;
      } else {
        addErrorToast(businessUpdateRequest.data.message);
        return;
      }
    } else {
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    formik.setValues({
      ...formik.values,
      [name]: value,
    });
  };

  if (!userToken || userToken.length < 1) {
    navigate("/", { replace: true });
  }

  React.useEffect(() => {
    let myBusinessProfile = userReduxState?.userData?.myBusinessProfile ?? {}

    dispatch(dashboardActions.setSchoolData(myBusinessProfile));
    const socialLink = myBusinessProfile?.socialLink;
    const socialArray = [];
    if (socialLink?.facebook) {
      socialArray.push("facebook");
    }
    if (socialLink?.instagram) {
      socialArray.push("instagram");
    }
    if (socialLink?.linkedIn) {
      socialArray.push("linkedIn");
    }
    if (socialLink?.twitter) {
      socialArray.push("twitter");
    }
    if (socialLink?.youtube) {
      socialArray.push("youtube");
    }
    // setAddress({ ...dashboardReduxState.schoolData.locationObj });
    setSocialLinksSelected([...socialArray]);
    formik.setValues({
      ...myBusinessProfile,
      socialLinksSelected: socialArray,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={"divide-y"}>
      <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 md:px-6 md:grid-cols-3 lg:px-8">
        <div>
          <h2 className="text-base/7 font-semibold">{t("account.organizationDetailsTitle")}</h2>
          <p className="mt-1 text-sm/6 text-gray-400">{t("account.organizationDetailsSubTitle")}</p>
        </div>
        <form className={"flex flex-col gap-4 md:col-span-2"} onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
          <BusinessProfileImgInput
            setFieldValue={formik.setFieldValue}
            values={formik.values}
          />
          <TwInputGroup
            label={t("inputFieldsTitle.orgName")}
            placeholder={t(formik.values.businessProfileType === 'individual' ? "inputFieldsTitle.hostName" : "inputFieldsTitle.orgName")}
            name={"businessName"}
            leftIcon={(<img className={""} src={formik.values.businessProfileType === 'individual' ? individual_profile : institute_img} alt={""} />)}
            value={formik.values?.businessName}
            onChange={handleInputChange}
            errors={formik.errors}
          />
          <TwTextarea
            label={t("inputFieldsTitle.aboutOrg")}
            name={"about"}
            row={3}
            value={formik.values?.about}
            onChange={handleInputChange}
            errors={formik.errors}
          />
          <div className={"flex flex-row items-center gap-2"}>
            <TwButton
              variant={"secondary"}
              className="sm:min-w-32 [md:w-full]"
              disabled={loadingReduxState.actionLoading || (!(formik.isValid && formik.dirty) && !formik.isSubmitting) || isThereChange.od}
              actionLoading={loadingReduxState.actionLoading}
              onClick={formik.submitForm}
            >
              {t("update")}
            </TwButton>
          </div>
        </form>
      </div >
      <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 md:px-6 md:grid-cols-3 lg:px-8">
        <div>
          <h2 className="text-base/7 font-semibold">{t("account.contactDetailsTitle")}</h2>
          <p className="mt-1 text-sm/6 text-gray-400">{t("account.contactDetailsSubTitle")}</p>
        </div>
        <form className={"flex flex-col gap-4 md:col-span-2"} onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
          <BusinessProfileForm
            form={formik}
            formErros={formik.errors}
            setUpdateLocationConfig={setUpdateLocationConfig}
            setLocationChanged={setLocationChanged}
            showContactDetails={true}
          />
          <div className={"flex flex-row justify-start items-start gap-2"}>
            <TwButton
              variant={"secondary"}
              className="sm:min-w-32"
              disabled={loadingReduxState.actionLoading || (!(formik.isValid && formik.dirty) && !formik.isSubmitting) || isThereChange.cd}
              actionLoading={loadingReduxState.actionLoading}
              onClick={formik.submitForm}
            >
              {t("update")}
            </TwButton>
          </div>
        </form>
      </div>
      <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 md:px-6 md:grid-cols-3 lg:px-8">
        <div>
          <h2 className="text-base/7 font-semibold">{t("account.socialDetailsTitle")}</h2>
          <p className="mt-1 text-sm/6 text-gray-400">{t("account.socialDetailsSubTitle")}</p>
        </div>
        <form className={"flex flex-col gap-4 md:col-span-2"} onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
          <TwInputGroup
            label={t("inputFieldsTitle.organizationWebsiteOpt")}
            placeholder={t("inputFieldsTitle.websiteOptPlaceholder")}
            name={"workWebsite"}
            leftIcon={(<img className={""} src={web_img} alt={""} />)}
            value={formik.values?.workWebsite}
            onChange={handleInputChange}
            errors={formik.errors}
          />
          <div className={"flex flex-col"}>
            <div className={"mt-2"}>
              <h4 className={"font-medium text-lg"}>
                {t("inputFieldsTitle.linkToSocialMedia")}
              </h4>
              <div className="flex items-center gap-3 mt-5">
                {defaultSocialLinks.map((data) => (
                  <button
                    type="button"
                    key={data.name}
                    // onClick={() => setSelected(id)}
                    onClick={(event, newFormats) => {
                      let tempSocialLinksSelected = [...socialLinksSelected];
                      tempSocialLinksSelected = tempSocialLinksSelected.includes(data.name) ? tempSocialLinksSelected.filter(item => item !== data.name) : [...tempSocialLinksSelected, data.name]
                      formik.setFieldValue("socialLinksSelected", tempSocialLinksSelected);
                      setSocialLinksSelected(tempSocialLinksSelected)
                    }}
                    className={`relative w-10 h-10 md:w-16 md:h-16 rounded-full flex items-center justify-center border transition 
            ${(formik.values?.socialLinksSelected && formik.values.socialLinksSelected.indexOf(data.name) !== -1) ? "bg-gray-100 border-gray-300" : "bg-white border-gray-300"}`}
                  >
                    <img className={"w-4 md:w-6"} src={data.icon} alt={""} />
                    {/* {(formik.values?.socialLinksSelected && formik.values.socialLinksSelected.indexOf(data.name) !== -1) && (
                      <span className="absolute -top-2 -left-2 bg-green-600 text-white w-6 h-6 rounded-full flex items-center justify-center text-sm">
                        ✓
                      </span>
                    )} */}
                    {(formik.values?.socialLinksSelected && formik.values.socialLinksSelected.indexOf(data.name) !== -1) ? (<img className={"absolute w-5 md:w-8 indicator-item border-0 p-0 badge badge-lg -left-4 -top-2 md:-left-4 md:top-2 [-translate-y-3 translate-x-3 md:-translate-y-6 md:translate-x-6]"} src={progressdone} alt={""} />) : ""}
                  </button>
                ))}
              </div>
              {/* <div className="flex flex-row gap-2 mt-5">
                <ToggleButtonGroup
                  value={socialLinksSelected}
                  onChange={(event, newFormats) => {
                    formik.setFieldValue("socialLinksSelected", newFormats);
                    setSocialLinksSelected(newFormats);
                  }}
                  aria-label="text alignment"
                >
                  {defaultSocialLinks.map((data, i) => {
                    return (
                      <ToggleButton
                        key={i}
                        value={data.name}
                        className={classNames("!rounded-full !border-0 !p-0 !mr-3")}
                      >
                        <div className={classNames("relative indicator cursor-pointer flex justify-center items-center rounded-full w-10 h-10 md:w-16 md:h-16 border !border-gray-300",
                          (formik.values?.socialLinksSelected && formik.values.socialLinksSelected.indexOf(data.name) !== -1)
                            ? "#0000000A"
                            : "#FFFFFF"
                        )} >
                          <img className={"w-4 md:w-6"} src={data.icon} alt={""} />
                          {(formik.values?.socialLinksSelected && formik.values.socialLinksSelected.indexOf(data.name) !== -1) ? (<img className={"absolute w-5 md:w-8 indicator-item border-0 p-0 badge badge-lg -left-4 -top-2 md:-left-4 md:top-2 [-translate-y-3 translate-x-3 md:-translate-y-6 md:translate-x-6]"} src={progressdone} alt={""} />) : ""}

                        </div>
                      </ToggleButton>
                    );
                  })}
                </ToggleButtonGroup>
              </div> */}
            </div>
            <div className="flex flex-col gap-3 my-3">
              {defaultSocialLinks.map((data, i) => {
                return (
                  formik.values?.socialLinksSelected && formik.values.socialLinksSelected.indexOf(data.name) !== -1 && (

                    <div className="flex flex-row items-center gap-3" key={i}>
                      <TwInputGroup
                        // label={"Name"}
                        placeholder={data.placeholder}
                        // name={"socialLink.facebook"}
                        name={`socialLink.${data.name}`}
                        value={formik.values.socialLink[data.name]}
                        leftIcon={(<img className={"size-4 md:size-6"} src={data.icon} alt={""} />)}
                        onChange={(event) => {
                          formik.setFieldValue("socialLink." + data.name, event.target.value);
                        }}
                        errors={formik.errors}
                      />
                      <button
                        onClick={() => {
                          let linksSelected = [...formik.values.socialLinksSelected];
                          linksSelected = linksSelected.filter(
                            (link) => link !== data.name
                          );
                          formik.setFieldValue("socialLinksSelected", linksSelected);
                          formik.setFieldValue("socialLink." + data.name, "");
                        }}
                      >
                        <MinusCircleIcon className="size-6 text-secondary" />
                      </button>
                    </div>
                  )
                );
              })}
            </div>
          </div>
          <div className={"flex flex-row justify-start items-start gap-2"}>
            <TwButton
              variant={"secondary"}
              className="sm:min-w-32"
              disabled={loadingReduxState.actionLoading || (!(formik.isValid && formik.dirty) && !formik.isSubmitting) || isThereChange.sd}
              actionLoading={loadingReduxState.actionLoading}
              onClick={formik.submitForm}
            >
              {t("update")}
            </TwButton>
          </div>
        </form>
      </div>

      <OtpModal
        open={openOtpModal}
        handleClose={handleCloseOtpModal}
        title={otpTitle}
        subTitle={otpSubTitle}
        values={formik.values}
        reqToken={otpToken}
        categories={categories}
        locationChanged={locationChanged}
        updateLocationConfig={updateLocationConfig}
        setLoading={setLoading}
        onSubmit={async () => {
          await updateProfileForAll(formik.values)
        }}
      />
      <TwConfirmDialog
        dialogOpen={showNameChangedModal}
        dialogType="error"
        dialogTitle={t("account.nameChangedModalTitle")}
        dialogMessage={t("account.nameChangedModalSubTitle", { businessType: userReduxState?.businessType && userReduxState?.businessType !== "" ? businessTypePlural[userReduxState.businessType] : "classes" })}
        onClose={async () => {
          setShowNameChangedModal(false);
        }}
        onConfirm={async () => {
          setDialogShow(true);
          setShowNameChangedModal(false);
          formik.submitForm();
        }}
      />
    </ div >
  );
}
